import 'parsleyjs/dist/parsley.js'
import 'parsleyjs/dist/i18n/zh_cn.js'
const locales = ['en', 'zh_cn']
const documentLocale = (
  document.documentElement.getAttribute('lang') || ''
).toLowerCase()

$.extend<ParsleyOptions, Partial<ParsleyOptions>>(window.Parsley.options, {
  // Default options for bootstrap 4 with bootstrap-select
  classHandler({ $element }) {
    if ($.inArray($element.attr('type'), ['checkbox', 'radio']) !== -1) {
      return $element.closest('.form-group')
    }
    if ($element.is('select') && $element.parent().is('.bootstrap-select')) {
      return $element.parent()
    }
    return $element
  },
  errorsContainer({ $element }) {
    return $element.closest('.form-group')
  },
  errorClass: 'is-invalid',
  errorsWrapper: '<div class="invalid-feedback"></div>',
  errorTemplate: '<span></span>',
  successClass: 'is-valid',
  trigger: 'blur propertychange change',
  triggerAfterFailure: 'input change'
})

window.Parsley.setLocale(
  locales.includes(documentLocale) ? documentLocale : locales[0]
)

export const init = (form: HTMLElement): void => {
  $(form).parsley()
}
